// src/components/RelatedBlogs.js
import React, { useState, useEffect } from 'react';

import { fetchBlogPosts } from '../services/apiService';
import ArticleCard from './ArticleCard';

const shuffleArray = (array) => {
  let currentIndex = array.length, randomIndex;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
};

const RelatedBlogs = ({ currentPostId, category }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getRelatedPosts = async () => {
      setLoading(true);
      try {
        // ✅ FIX: Destructure the 'posts' array from the response object.
        const { posts: allPosts } = await fetchBlogPosts({ perPage: 100 });
        
        // ✅ FIX: Use the correctly destructured 'allPosts' array here.
        let filteredPosts = allPosts.filter(p => p.id !== currentPostId);
        
        if (category) {
            const categoryPosts = filteredPosts.filter(p => p.categories.some(c => c.name === category));
            const otherPosts = filteredPosts.filter(p => !p.categories.some(c => c.name === category));
            filteredPosts = [...shuffleArray(categoryPosts), ...shuffleArray(otherPosts)];
        } else {
            filteredPosts = shuffleArray(filteredPosts);
        }
        setPosts(filteredPosts.slice(0, 4));
      } catch (err) {
        console.error("Failed to fetch related blog posts:", err);
      } finally {
        setLoading(false);
      }
    };

    getRelatedPosts();
  }, [currentPostId, category]);

  if (loading || posts.length < 4) { // Only show the section if we have enough posts
    return null;
  }

  return (
    // ✅ WRAPPED in a bg-dark-bg container to ensure correct theme application
    <section className="bg-dark-bg py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
                Continue Reading
            </h2>
            <p className="mt-4 text-lg text-dark-text-secondary">
                Explore more insights on AI, social media, and building a brand that lasts.
            </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:mt-20 md:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-4">
          {posts.map(p => <ArticleCard key={p.id} post={p} />)}
        </div>
      </div>
    </section>
  );
};

export default RelatedBlogs;